export const castMembers = [
  {
    id: 1,
    name: '沈知微',
    role: '林小满',
    initial: 'S',
    tagline: '她是这个家里最不该回来的人，也是最舍不得走的人。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20cinematic%20portrait%20of%20a%20young%20East%20Asian%20woman%20in%20a%20soft%20ivory%20knit%20sweater%2C%20warm%20studio%20light%2C%20deep%20crimson%20backdrop%2C%20calm%20expressive%20eyes%2C%20editorial%20film%20poster%20photography%2C%20subtle%20film%20grain%2C%20no%20text%2C%20refined%20minimal%20composition&width=600&height=800&seq=cast-01-shen&orientation=portrait',
    bio: '沈知微，1994 年生于杭州，毕业于中央戏剧学院表演系。以细腻克制的表演风格受到关注，擅长在沉默中完成情绪转折。曾出演《长夜有灯》《山中来信》等作品，凭借对复杂女性角色的把握获得年度新锐演员提名。',
    roleIntro: '林小满在剧中是顾家最小的女儿，也是七年前那场家庭变故中被送走的人。她带着一封信回到老宅，想弄清楚自己究竟被谁推开，又为什么一直放不下这个家。',
    relatedEpisodes: [1, 3, 6, 10, 12],
  },
  {
    id: 2,
    name: '陆沉舟',
    role: '顾长川',
    initial: 'L',
    tagline: '他把整个家扛在肩上，却始终没学会怎么开口。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20composed%20East%20Asian%20man%20in%20his%20thirties%20wearing%20a%20dark%20charcoal%20shirt%2C%20deep%20burgundy%20background%2C%20warm%20side%20lighting%2C%20restrained%20serious%20expression%2C%20editorial%20film%20still%20photography%2C%20soft%20grain%2C%20no%20text%2C%20elegant%20minimal%20composition&width=600&height=800&seq=cast-02-lu&orientation=portrait',
    bio: '陆沉舟，1990 年生于北京，演员、舞台剧出身。以低音嗓音和克制的表演节奏著称，近年转向影视，在《雾港》《归途列车》中塑造了多个内敛角色。为了顾长川一角，他提前两个月学习木工与茶道。',
    roleIntro: '顾长川是顾家长子，接手家业十年。他习惯替所有人做决定，也习惯把情绪收起来。小满的归来让他不得不面对自己当年没有阻止的那件事。',
    relatedEpisodes: [1, 2, 4, 6, 10, 12],
  },
  {
    id: 3,
    name: '温以宁',
    role: '苏婉',
    initial: 'W',
    tagline: '她签下那份协议的时候，以为自己在保护所有人。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20an%20elegant%20East%20Asian%20woman%20in%20her%20late%20thirties%20wearing%20a%20deep%20wine%20red%20blouse%2C%20ivory%20soft%20background%2C%20refined%20warm%20lighting%2C%20composed%20thoughtful%20expression%2C%20editorial%20film%20photography%2C%20subtle%20grain%2C%20no%20text%2C%20luxurious%20restrained%20style&width=600&height=800&seq=cast-03-wen&orientation=portrait',
    bio: '温以宁，1988 年生于上海，毕业于上海戏剧学院。长期活跃于都市情感题材，以精准的情绪控制见长，代表作包括《半城》《春深》。在片场她常主动与年轻演员对词，被剧组称为「定海神针」。',
    roleIntro: '苏婉是林小满的姐姐，也是顾长川的妻子。她温婉、周全，善于把家维持得体面。七年前那份协议上，签的是她的名字，而她始终相信那是唯一的选择。',
    relatedEpisodes: [2, 3, 8, 11],
  },
  {
    id: 4,
    name: '高柏',
    role: '顾老爷子',
    initial: 'G',
    tagline: '他守住了房子，却没守住屋子里的人。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20an%20elderly%20East%20Asian%20man%20with%20silver%20hair%20wearing%20a%20warm%20brown%20traditional%20jacket%2C%20deep%20crimson%20background%2C%20soft%20directional%20light%2C%20dignified%20weathered%20expression%2C%20editorial%20film%20still%2C%20fine%20grain%2C%20no%20text%2C%20dignified%20minimal%20composition&width=600&height=800&seq=cast-04-gao&orientation=portrait',
    bio: '高柏，1956 年生于南京，国家一级演员，从艺四十余年。以沉稳厚重的话剧表演功底闻名，曾在多部年代戏中出演家族长辈。拍摄期间坚持每天提前一小时到现场，被年轻演员称作「顾家的定盘星」。',
    roleIntro: '顾老爷子是顾家的掌舵人，一生要强。他用沉默维持家中的秩序，也用沉默埋下了所有裂缝。病倒之后，他第一次说出「灯不能灭」。',
    relatedEpisodes: [2, 5, 10, 11, 12],
  },
  {
    id: 5,
    name: '白露',
    role: '沈曼',
    initial: 'B',
    tagline: '她只是路过那场事故，却记了整整七年。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20mysterious%20East%20Asian%20woman%20in%20a%20dark%20coat%20with%20short%20hair%2C%20moody%20warm%20amber%20light%2C%20deep%20red%20textured%20background%2C%20guarded%20expression%2C%20editorial%20film%20noir%20photography%2C%20soft%20grain%2C%20no%20text%2C%20elegant%20suspenseful%20mood&width=600&height=800&seq=cast-05-bai&orientation=portrait',
    bio: '白露，1996 年生于成都，独立电影出身，以强烈个人气质受到关注。她擅长处理带有秘密感的角色，作品《河岸》《无名之夜》曾入围多个国际影展。本剧中她主动提出为沈曼设计了一段无台词的开场。',
    roleIntro: '沈曼是七年前那场事故中唯一在场的旁人。她带着一段录音回到这座城市，既不站在顾家一边，也不打算替谁开脱。',
    relatedEpisodes: [7, 8, 11],
  },
  {
    id: 6,
    name: '程亦',
    role: '周衍',
    initial: 'C',
    tagline: '他谈的是生意，问的却是旧事。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20sharp%20East%20Asian%20man%20in%20a%20tailored%20dark%20suit%2C%20warm%20ivory%20studio%20background%2C%20controlled%20confident%20expression%2C%20subtle%20red%20tie%20accent%2C%20editorial%20film%20photography%2C%20fine%20grain%2C%20no%20text%2C%20modern%20refined%20minimal%20style&width=600&height=800&seq=cast-06-cheng&orientation=portrait',
    bio: '程亦，1992 年生于深圳，模特转型演员。以干净利落的银幕形象被观众记住，在《边界》《冬日合约》中饰演多位职场角色。本剧中他为周衍设计了大量细节动作，让这个看似温和的角色始终带着一丝不确定。',
    roleIntro: '周衍是顾家的合作方，也是最早察觉股权文件异常的人。他游走在顾家与外部资本之间，立场始终暧昧。',
    relatedEpisodes: [5, 7, 11],
  },
  {
    id: 7,
    name: '姜黎',
    role: '何薇薇',
    initial: 'J',
    tagline: '她替所有人说话，唯独不替自己。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20friendly%20East%20Asian%20woman%20in%20her%20late%20twenties%20with%20a%20soft%20bob%20haircut%2C%20warm%20cream%20background%2C%20gentle%20natural%20light%2C%20bright%20sincere%20expression%2C%20editorial%20film%20photography%2C%20subtle%20grain%2C%20no%20text%2C%20warm%20approachable%20composition&width=600&height=800&seq=cast-07-jiang&orientation=portrait',
    bio: '姜黎，1997 年生于武汉，毕业于北京电影学院。以自然松弛的表演风格见长，常在作品中出演推动剧情的关键配角。她在本剧中同时担任部分场记工作，被剧组笑称「剧组最忙的人」。',
    roleIntro: '何薇薇是顾家的家庭医生，也是小满少年时期唯一的朋友。她清楚这个家所有的病历，却从不多问一句。',
    relatedEpisodes: [2, 4, 9, 10],
  },
  {
    id: 8,
    name: '邵川',
    role: '林父',
    initial: 'S',
    tagline: '他把女儿送走的那天，什么理由都没有给。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20middle-aged%20East%20Asian%20man%20with%20a%20weathered%20face%20wearing%20a%20simple%20grey%20coat%2C%20dark%20warm%20background%2C%20soft%20window%20light%2C%20sorrowful%20restrained%20expression%2C%20editorial%20film%20still%2C%20subtle%20grain%2C%20no%20text%2C%20quiet%20melancholic%20composition&width=600&height=800&seq=cast-08-shao&orientation=portrait',
    bio: '邵川，1971 年生于西安，实力派性格演员。擅长在有限的戏份中建立人物的重量，出演过《老城》《渡口》等作品。本剧中他的戏份不多，但每一次出现都改变了小满对过去的判断。',
    roleIntro: '林父是林小满与苏婉的父亲。七年前，是他亲手把女儿送上离开的车，此后从未解释原因。',
    relatedEpisodes: [1, 8, 9, 12],
  },
];